// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"41":"37ff9d8e","885":"7ef30e57"}[chunkId] + ".js";
};